export { default } from "./FAQPage";
